module.exports = __webpack_public_path__ + "img/sec01-02.891c917d.png";